import { useState } from "react";
import { Children, cloneElement } from "react";
import "./HomeWhoAreWe.css";

function ReadMoreText({ children, className = "" }) {
  const [expanded, setExpanded] = useState(false);

    const childArray = Children.toArray(children);

  return (
    <div
      className={`read-more-wrapper ${className} ${
        expanded ? "expanded" : "collapsed"
      }`}
    >
     <div className="read-more-content">
        {childArray.map((child, index) => {
          const isLastChild = index === childArray.length - 1;

          if (expanded && isLastChild && child.type === "p") {
            return cloneElement(child, {
              children: (
                <>
                  {child.props.children}
                  <button
                    type="button"
                    className="read-less-btn-home"
                    onClick={() => setExpanded(false)}
                  >
                    Read Less
                  </button>
                </>
              ),
            });
          }

          return child;
        })}
      </div>

      {!expanded && (
        <button
          type="button"
          className="read-more-btn"
          onClick={() => setExpanded(true)}
        >
          ... <span>Read More</span>
        </button>
      )}
    </div>
  );
}

function HomeWhoAreWe() {
  return (
    <div className="who-are-we-container">
      {/* ================= TOP SECTION ================= */}
      <div className="top-section section-padding">

        {/* Decorative Image */}
        <img
          src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/dot.png"
          alt=""
          className="home-absolute-image"
        />

        <div className="top-content-wrapper">

          {/* ================= MOBILE / TABLET HEADING ================= */}
          <h2
            className="heading-title home-title mobile-about-title"
            style={{ textAlign: "left" }}
          >
            About <span className="title-blue">TNS Global</span>
          </h2>

          {/* ================= TEAM IMAGE ================= */}
          <div className="team-image-container">
            <img
              src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/home-abt.png"
              alt="TNS Global Team"
              className="home-team-image"
            />
          </div>

          {/* ================= TEXT CONTENT ================= */}
          <div className="text-content">

            {/* Desktop Heading */}
            <h2
              className="heading-title home-title desktop-about-title"
              style={{ textAlign: "left" }}
            >
              About <span className="title-blue">TNS Global</span>
            </h2>

            {/* ================= WHO ARE WE ================= */}
            <h2
              className="heading-title2 who-heading"
              style={{ textAlign: "left" }}
            >
              Who Are We
            </h2>

            <ReadMoreText className="who-content">

              <p>
                Travel Network Solutions (TNS Global) was founded by aviation
                professionals with decades of hands-on experience running
                commercial aviation and logistics operations across Africa,
                the Middle East, and Asia. That operating experience — not
                just technology reselling — sits behind our exclusive
                partnership with Sabre Corporation, a global leader in travel
                technology.
              </p>

              <p>
                We understand what it takes to move people and cargo reliably
                through complex, fast-growing markets, because we've done it.
                That's the expertise we bring to every agency we support.
              </p>

            </ReadMoreText>

            {/* ================= DIVIDER ================= */}
            <div className="feature-line"></div>

            {/* ================= WHAT DO WE DO ================= */}
            <h2
              className="heading-title2 what-heading"
              style={{ textAlign: "left" }}
            >
              What Do We Do
            </h2>

            <ReadMoreText className="what-content">

              <p>
                Our partnership with Sabre brings one of the world's most
                advanced Global Distribution Systems (GDS) to travel agencies,
                tour operators, and corporate travel teams across Africa.
                Through Agency Workspace and the Sabre Mosaic Travel
                Marketplace, agents get a single, unified workflow across
                GDS, NDC, and low-cost carrier content — backed by local,
                on-the-ground support so the technology actually gets used,
                not just installed.
              </p>

              <p>
                This is more than distribution. It's a long-term partnership
                built to modernize how African travel agencies operate,
                compete, and grow.
              </p>

            </ReadMoreText>

          </div>
        </div>
      </div>

      {/* ================= BOTTOM SECTION ================= */}
      <div className="bottom-section">

        <img
          src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/why-bg.png"
          alt=""
          className="bottom-section-img"
        />

        <div className="bottom-content-wrapper">

          <div className="empowering-content section-padding">

            <h2
              className="heading-title"
              style={{ color: "#1E1E1E" }}
            >
              Why Choose <span className="title-blue">TNS Global?</span>
            </h2>

            <p
              className="desc"
              style={{ color: "#3A3A3A" }}
            >
              TNS Global is more than a distributor—we are a long-term
              technology partner helping African travel agencies modernize
              operations, adopt smarter GDS solutions, and run business with
              global standards.
            </p>

            {/* ================= FEATURES ================= */}
            <div className="features">

              {/* Feature 1 */}
              <div className="feature-item">
                <img
                  className="feature-icon"
                  src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/why-icon1.svg"
                  alt="Exclusive Sabre Partnership"
                />

                <span>
                  Exclusive Sabre Partnership
                </span>

                <p>
                  Access Sabre's world-leading GDS solutions with localized
                  implementation, Africa-focused configuration, and real-time
                  global inventory.
                </p>
              </div>

              {/* Feature 2 */}
              <div className="feature-item">
                <img
                  className="feature-icon"
                  src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/why-icon2.svg"
                  alt="Local Expertise"
                />

                <span>
                Trusted Local Expertise
                </span>

                <p>
                  Our teams operating across multiple African markets
                  understand regional booking patterns, supplier dynamics,
                  internet challenges, and customer expectations.
                </p>
              </div>

              {/* Feature 3 */}
              <div className="feature-item">
                <img
                  className="feature-icon"
                  src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/why-icon3.svg"
                  alt="Dedicated Support"
                />

                <span>
                  Dedicated Support
                </span>

                <p>
                  Certified trainers, product specialists, and technical
                  engineers ensure ongoing onboarding, troubleshooting, and
                  performance optimization.
                </p>
              </div>

              {/* Feature 4 */}
              <div className="feature-item">
                <img
                  className="feature-icon"
                  src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/why-icon4.svg"
                  alt="Future-Ready Solutions"
                />

                <span>
                  Future-Ready Solutions
                </span>

                <p>
                  We provide automation and corporate travel tools that
                  streamline ticketing, invoicing, reporting, and fare
                  management to reduce manual work.
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeWhoAreWe;
